<template>
  <div class='tasks'>
    <div class="operation-bar">
      <div class="float-right">
        <tasks-operation :selected-ids="selectedIds"></tasks-operation>
        <form class="form form-inline float-right">
          <search-group :p-search-group="searchGroup"></search-group> 
        </form>
      </div>
    </div>
    <div class="clearfix"></div>
    <pager v-bind:items='this.tasks || []'></pager>
    <div class="">
      <table class='table table-sm table-hover'>
        <thead class="thead-default">
          <th v-on:click='toggleCheckAll()' nowrap>
            <input class='main-input-toggle' title='选择所有' type='checkbox'>
            <span v-if="selectedIds.length"> X{{selectedIds.length}}</span>
          </th>
          <th>ID</th>
          <th>任务名</th>
          <th>任务类型</th>
          <th>创建时间</th>
          <th>产品类型</th>
          <th>订单</th>
          <th>状态</th>
          <th>操作</th>
        </thead>
        <tbody>
          <tr v-for="task of tasks" :class="calculateRowColor(task)">
            <td>
              <input 
                class='sub-input-toggle' 
                type='checkbox' 
                :data-id='task.id'
                :checked="selectedIds.indexOf(String(task.id)) >= 0"
                @click="toggleCheck">
            </td>
            <td><router-link :to="'/tasks/' + task.id">{{task.id}}</router-link></td>
            <td>{{task.name}}</td>
            <td>{{getTaskTypeDisplay(task.task_type)}}</td>
            <td>
              <local-time :time="task.created_at"></local-time>  
            </td>
            <td>
              {{task.product_names.join(",")}}<br/>
                {{task.arg1}}
            </td>
            <td>{{task.data.order_nos ? task.data.order_nos.length:task.arg2}}个</td>
            <td>{{getTaskStatusDisplay(task.status)}}</td>
            <td><button class="btn btn-sm btn-primary fa fa-trash-o" @click="deleteTask(task.id)"></button></td>
          </tr>
        </tbody>  
      </table>
    </div>
  </div>
</template>

<script>
import Pager from '@/components/_partial/Pager'
import SearchGroup from '@/components/_partial/SearchGroup'
import TasksOperation from '@/components/_tasks/TasksOperation'
import TasksSearch from '@/components/_tasks/TasksSearch'
import InputMixin from '@/mixins/input'
import OrderMixin from '@/mixins/order'
import TaskMixin from '@/mixins/task'
import LoadDataMixin from '@/mixins/load_data'
import {showFailedAlert} from '@/utils/alert'
import LocalTime from '@/components/_small/LocalTime'

function loadData () {
  this.$http.doSpin()
  this.$http.get('/api/tasks' + location.search).then(response => {
    this.$http.cancelSpin()
    document.querySelector('.main-input-toggle').checked = false
    this.tasks = response.data.data
  })
  .catch(function (error) {
    this.$http.cancelSpin()
    console.log(error)
  })
}

function calculateRowColor (task) {
  if (task.status === 'failed' || task.status === 'cancelled') {
    return 'table-danger'
  } else if (task.status === 'succeeded') {
    return 'table-success'
  } else {
    return ''
  }
}

function deleteTask (taskId) {
  let confirm = prompt('删除任务不会重置订单状态\n订单的状态可能依然是拼版完成\n请确保该任务的订单不会被遗漏\n\n输入该任务的ID继续')
  if (String(taskId) !== confirm) {
    showFailedAlert('您输入的任务ID不正确')
    return
  }

  this.$http.delete('/api/tasks/' + taskId).then(response => {
    this.loadData()
  })
}

function calculateSearchGroup () {
  return {
    name: '任务名',
    key: 'name',
    value: '',
    menus: [
      {
        key: 'name', name: '任务名'
      }, {
        key: 'id', name: '任务ID'
      }
    ]
  }
}

export default {
  name: 'tasks',
  mixins: [InputMixin, OrderMixin, TaskMixin, LoadDataMixin],
  data () {
    return {
      tasks: []
    }
  },
  mounted () {
    this.loadData()
  },
  components: {
    Pager,
    TasksOperation,
    TasksSearch,
    LocalTime,
    SearchGroup
  },
  methods: {
    loadData,
    calculateRowColor,
    deleteTask,
    calculateSearchGroup
  },
  computed: {
    searchGroup () {
      return this.calculateSearchGroup()
    }
  }
}
</script>

<style lang='scss' scoped>
</style>